import {pagination} from "@/components/Paggination/Paggination";
import mockDetailOperationsCommerciales from "@/data/getOperationCommerciale.json";
import mockOperationsCommerciales from "@/data/getOperationsCommerciales.json";
import {getBFF} from "@/function/getUrlProdOrPreprod";
import {
  ApiReponseCardOperationCommerciale,
  CommandeAPI,
  OperationCommerciale,
} from "@/ts/interface/operationCommerciale";
import {Commande} from "@/ts/interface/operationCommerciale";

import {getDataMock} from "./_callApi";
import {callApi} from "./_callApi";

export async function FetchOperationsCommerciales(
  filtre?: string[],
  page: number = 1,
  hitsPerPage: number = 50,
): Promise<ApiReponseCardOperationCommerciale | undefined> {
  if (getDataMock()) {
    const OpCo: ApiReponseCardOperationCommerciale = mockOperationsCommerciales;
    return OpCo;
  }
  let reponse = undefined;
  try {
    if (import.meta.env.VITE_APP_DEV === "true") {
      reponse = await callApi(
        `${import.meta.env.VITE_APP_API}/api/operation/v1/operations?${filtre ? filtre.join("&") : ""}&page=${page}&hitsPerPage=${hitsPerPage}`,
        "GET",
        {
          Authorization:
            "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzUxMiIsImtpZCI6IjEifQ.eyJpYXQiOjE3NTQ2NTU4ODguNzU2NzY3LCJuYmYiOjE3NTQ2NTU4ODguNzU2NzY3LCJleHAiOjIwNzAxODg2ODguNzU2NzY3LCJzdWIiOiJjeXJpbEBicmljb3Bybzc5LmZyIiwiY29udHJlbWFycXVlIjoiMTA0MDAwIiwiZXh0cmFuZXQtaWQiOiIxNzgifQ.ATetmxOXN-UhksNfGbGrxg3Tn5eiuJv7iI-_jfd2Jg70cH-dCoCyqc8d6OYTF07mMmNCUhsKZ9wcZIA1u7KEYQWdAOs90-2gUorR2ZKoJ3o7bis1WcTwZT2NmnCIXA_o51SzrCWba-Grf3rbTzhZaf65uatdhJtj1udI-taA--Y_uS_S",
        },
      );
    } else {
      reponse = await callApi(
        `${getBFF()}/operation/v1/operations?${filtre ? filtre.join("&") : ""}`,
        "GET",
        {
          "Content-Type": "application/json",
          "Accept-Encoding": "gzip, deflate, br",
          "X-Massification-CSRF-Token": csrf,
          "X-CoDeals-CSRF-Token": csrf,
        },
        "include",
        null,
      );
    }
  } catch (error: any) {
    throw new Error(error?.message);
  }
  return reponse;
}

export async function FetchOperationCommerciale(
  id: string,
): Promise<OperationCommerciale | undefined> {
  if (getDataMock()) {
    const OpCo: OperationCommerciale = mockDetailOperationsCommerciales;
    return OpCo;
  }
  let reponse = undefined;

  if (import.meta.env.VITE_APP_DEV === "true") {
    reponse = await callApi(
      `${import.meta.env.VITE_APP_API}/api/operation/v1/operations/${id}`,
      "GET",
      {
        Authorization:
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzUxMiIsImtpZCI6IjEifQ.eyJpYXQiOjE3NTQ2NTU4ODguNzU2NzY3LCJuYmYiOjE3NTQ2NTU4ODguNzU2NzY3LCJleHAiOjIwNzAxODg2ODguNzU2NzY3LCJzdWIiOiJjeXJpbEBicmljb3Bybzc5LmZyIiwiY29udHJlbWFycXVlIjoiMTA0MDAwIiwiZXh0cmFuZXQtaWQiOiIxNzgifQ.ATetmxOXN-UhksNfGbGrxg3Tn5eiuJv7iI-_jfd2Jg70cH-dCoCyqc8d6OYTF07mMmNCUhsKZ9wcZIA1u7KEYQWdAOs90-2gUorR2ZKoJ3o7bis1WcTwZT2NmnCIXA_o51SzrCWba-Grf3rbTzhZaf65uatdhJtj1udI-taA--Y_uS_S",
      },
    );
  } else {
    reponse = await callApi(
      `${getBFF()}/operation/v1/operations/${id}`,
      "GET",
      {
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate, br",
        "X-Massification-CSRF-Token": csrf,
        "X-CoDeals-CSRF-Token": csrf,
      },
      "include",
      null,
    );
  }
  return reponse;
}

export async function PostCommandeOperationCommerciale(
  commande: Commande,
): Promise<any> {
  if (import.meta.env.VITE_APP_DEV === "true") {
    const reponse = await callApi(
      `${import.meta.env.VITE_APP_API}/api/operation/v1/orders`,
      "POST",
      {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzUxMiIsImtpZCI6IjEifQ.eyJpYXQiOjE3NTQ2NTU4ODguNzU2NzY3LCJuYmYiOjE3NTQ2NTU4ODguNzU2NzY3LCJleHAiOjIwNzAxODg2ODguNzU2NzY3LCJzdWIiOiJjeXJpbEBicmljb3Bybzc5LmZyIiwiY29udHJlbWFycXVlIjoiMTA0MDAwIiwiZXh0cmFuZXQtaWQiOiIxNzgifQ.ATetmxOXN-UhksNfGbGrxg3Tn5eiuJv7iI-_jfd2Jg70cH-dCoCyqc8d6OYTF07mMmNCUhsKZ9wcZIA1u7KEYQWdAOs90-2gUorR2ZKoJ3o7bis1WcTwZT2NmnCIXA_o51SzrCWba-Grf3rbTzhZaf65uatdhJtj1udI-taA--Y_uS_S",
      },
      "same-origin",
      commande,
    );
    return reponse;
  } else {
    const reponse = await callApi(
      `${getBFF()}/operation/v1/orders`,
      "POST",
      {
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate, br",
        "X-Massification-CSRF-Token": csrf,
        "X-CoDeals-CSRF-Token": csrf,
      },
      "same-origin",
      commande,
    );
    return reponse;
  }
}

export async function PutCommandeOperationCommerciale(
  commande: Commande,
  commandeId: string,
): Promise<any> {
  if (import.meta.env.VITE_APP_DEV === "true") {
    const reponse = await callApi(
      `${import.meta.env.VITE_APP_API}/api/operation/v1/orders/${commandeId}`,
      "PUT",
      {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzUxMiIsImtpZCI6IjEifQ.eyJpYXQiOjE3NTQ2NTU4ODguNzU2NzY3LCJuYmYiOjE3NTQ2NTU4ODguNzU2NzY3LCJleHAiOjIwNzAxODg2ODguNzU2NzY3LCJzdWIiOiJjeXJpbEBicmljb3Bybzc5LmZyIiwiY29udHJlbWFycXVlIjoiMTA0MDAwIiwiZXh0cmFuZXQtaWQiOiIxNzgifQ.ATetmxOXN-UhksNfGbGrxg3Tn5eiuJv7iI-_jfd2Jg70cH-dCoCyqc8d6OYTF07mMmNCUhsKZ9wcZIA1u7KEYQWdAOs90-2gUorR2ZKoJ3o7bis1WcTwZT2NmnCIXA_o51SzrCWba-Grf3rbTzhZaf65uatdhJtj1udI-taA--Y_uS_S",
      },
      "same-origin",
      commande,
    );
    return reponse;
  } else {
    const reponse = await callApi(
      `${getBFF()}/operation/v1/orders/${commandeId}`,
      "PUT",
      {
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate, br",
        "X-Massification-CSRF-Token": csrf,
        "X-CoDeals-CSRF-Token": csrf,
      },
      "same-origin",
      commande,
    );
    return reponse;
  }
}

export async function FetchOperationCommercialeCommande(
  filtre?: string[],
  hitsPerPage: number = 100,
): Promise<{commandes: CommandeAPI[]; pagination: pagination} | undefined> {
  let reponse = undefined;
  if (import.meta.env.VITE_APP_DEV === "true") {
    reponse = await callApi(
      `${import.meta.env.VITE_APP_API}/api/operation/v1/orders?${filtre ? filtre.join("&") : ""}&hitsPerPage=${hitsPerPage}`,
      "GET",
      {
        Authorization:
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzUxMiIsImtpZCI6IjEifQ.eyJpYXQiOjE3NTQ2NTU4ODguNzU2NzY3LCJuYmYiOjE3NTQ2NTU4ODguNzU2NzY3LCJleHAiOjIwNzAxODg2ODguNzU2NzY3LCJzdWIiOiJjeXJpbEBicmljb3Bybzc5LmZyIiwiY29udHJlbWFycXVlIjoiMTA0MDAwIiwiZXh0cmFuZXQtaWQiOiIxNzgifQ.ATetmxOXN-UhksNfGbGrxg3Tn5eiuJv7iI-_jfd2Jg70cH-dCoCyqc8d6OYTF07mMmNCUhsKZ9wcZIA1u7KEYQWdAOs90-2gUorR2ZKoJ3o7bis1WcTwZT2NmnCIXA_o51SzrCWba-Grf3rbTzhZaf65uatdhJtj1udI-taA--Y_uS_S",
      },
    );
  } else {
    reponse = await callApi(
      `${getBFF()}/operation/v1/orders?${filtre ? filtre.join("&") : ""}`,
      "GET",
      {
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate, br",
        "X-Massification-CSRF-Token": csrf,
        "X-CoDeals-CSRF-Token": csrf,
      },
      "include",
      null,
    );
  }
  return reponse;
}
